import React from 'react'

const OracleComingSoon = () => (
  <div
    style={{
      alignItems: 'center',
      background: '#050806',
      border: '1px solid #173c25',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      height: '100%',
      justifyContent: 'center',
      minHeight: '320px',
      padding: '32px',
      textAlign: 'center',
    }}
  >
    <span style={{ color: '#00ff41', fontFamily: 'var(--font-header)', fontSize: '1.25rem' }}>
      ANALISTA ORÁCULO
    </span>
    <strong style={{ color: '#ffffff', fontFamily: 'var(--font-mono)', fontSize: '1.7rem' }}>
      BREVEMENTE
    </strong>
    <span style={{ color: '#789486', fontFamily: 'var(--font-mono)', maxWidth: '360px' }}>
      Esta funcionalidade está em preparação e será disponibilizada numa próxima atualização.
    </span>
  </div>
)

export default OracleComingSoon
